import ErrorCard from '../images/error-card';
import TimeImage from '../images/time';
import GroupsEmptyImage from '../images/groups-empty';
import GroupdetailsMapLayersEmptyImage from '../images/groupdetails-map-layers-empty';
import GroupdetailsAppsEmptyImage from '../images/groupdetails-apps-empty';
import GroupdetailsMembersEmptyImage from '../images/groupdetails-members-empty';
import GroupdetailsProjectsEmptyImage from '../images/groupdetails-projects-empty';
import NoResultsSearchImage from '../images/no-results-search';

export type FallbackOption = 'empty' | 'emptySearchResults' |
'emptyApps' | 'emptyLayers' | 'emptyMembers' | 'emptyProjects' |
'errorCard' | 'time';

export interface FallbackImageProps {
  src: FallbackOption;
  width?: string | number;
  height?: string | number;
}

const FallbackImages = {
  empty: GroupsEmptyImage,
  emptySearchResults: NoResultsSearchImage,
  emptyApps: GroupdetailsAppsEmptyImage,
  emptyLayers: GroupdetailsMapLayersEmptyImage,
  emptyMembers: GroupdetailsMembersEmptyImage,
  emptyProjects: GroupdetailsProjectsEmptyImage,
  errorCard: ErrorCard,
  time: TimeImage,
};

export default FallbackImages;
